import { Models } from "@hex-insights/app-modules";
import { Relationship } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the relationshipType field of the Relationship model.
 */
export function relationshipType(value: Relationship["relationshipType"]): string {
	return Models.toString(value);
}

/**
 * Formats the isPrimary field of the Relationship model.
 */
export function isPrimary(value: Relationship["isPrimary"]): string {
	return ModelFormat.yesNoBoolean(value);
}

/**
 * Formats the isFinancialContact field of the Relationship model.
 */
export function isFinancialContact(value: Relationship["isFinancialContact"]): string {
	return ModelFormat.yesNoBoolean(value);
}

/**
 * Formats the isEmergencyContact field of the Relationship model.
 */
export function isEmergencyContact(value: Relationship["isEmergencyContact"]): string {
	return ModelFormat.yesNoBoolean(value);
}

/**
 * Formats the isAuthorizedForPickup field of the Relationship model.
 */
export function isAuthorizedForPickup(value: Relationship["isAuthorizedForPickup"]): string {
	return ModelFormat.yesNoBoolean(value);
}

/**
 * Formats the livesWithStudent field of the Relationship model.
 */
export function livesWithStudent(value: Relationship["livesWithStudent"]): string {
	return ModelFormat.yesNoBoolean(value);
}

/**
 * Formats the hasCustody field of the Relationship model.
 */
export function hasCustody(value: Relationship["hasCustody"]): string {
	return ModelFormat.yesNoBoolean(value);
}
